/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "wysiwyg-italic-9ed1c5f1--sprite",
  "use": "wysiwyg-italic-9ed1c5f1--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"wysiwyg-italic-9ed1c5f1--sprite\"><rect width=\"36\" height=\"36\" rx=\"18\" fill=\"#e0e7f4\" opacity=\"0\" /><g transform=\"translate(14 12)\"><path d=\"M834.93,1261.813a.891.891,0,0,1-.9.9h-1.107l-2.2,8.1h.612a.9.9,0,1,1,0,1.8h-3.6a.9.9,0,1,1,0-1.8h1.116l2.214-8.1h-.63a.9.9,0,1,1,0-1.8h3.6A.9.9,0,0,1,834.93,1261.813Z\" transform=\"translate(-826.83 -1260.913)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
